export const branch = [
  { title: "Perlis", value: 0 },
  { title: "Kedah", value: 1 },
  { title: "Pulau Pinang", value: 2 },
  { title: "Perak", value: 3 },
  { title: "Selangor", value: 4 },
  { title: "Kuala Lumpur", value: 5 },
  { title: "Negeri Sembilan", value: 6 },
  { title: "Melaka", value: 7 },
  { title: "Johor", value: 8 },
  { title: "Pahang", value: 9 },
  { title: "Terengganu", value: 10 },
  { title: "Kelantan", value: 11 },
  { title: "Sabah", value: 12 },
  { title: "Sarawak", value: 13 }
];

export const states = [
  "Perlis",
  "Kedah",
  "Pulau Pinang",
  "Perak",
  "Selangor",
  "Kuala Lumpur",
  "Negeri Sembilan",
  "Melaka",
  "Johor",
  "Pahang",
  "Terengganu",
  "Kelantan",
  "Sabah",
  "Sarawak",
  "Labuan",
  "Putrajaya"
];

export const interests = [
  "GEMA Heroes",
  "GEMA Green Heroes",
  "GEMA Negative Heroes",
  "GEMA Horizon",
  "GEMA Muzik",
  "GEMA E-Sport",
  "GEMA Fit",
  "GEMA Future"
];

export const genders = ["LELAKI", "PEREMPUAN"];

export const races = [
  "MELAYU",
  "CINA",
  "INDIA",
  "IBAN",
  "BUGIS",
  "KADAZANDUSUN",
  "BAJAU",
  "MURUT",
  "LAIN-LAIN"
];

export const religions = [
  "ISLAM",
  "BUDDHA",
  "KRISTIAN",
  "HINDU",
  "SIKH",
  "LAIN-LAIN"
];

export const education = [
  "SPM",
  "STPM",
  "DIPLOMA",
  "SARJANA MUDA",
  "SARJANA",
  "DOKTOR FALSAFAH",
  "LAIN-LAIN"
];

export const weathers = [
  { title: "Cerah", value: "Cerah" },
  { title: "Mendung", value: "Mendung" },
  { title: "Hujan Renyai", value: "Hujan Renyai" },
  { title: "Hujan Lebat", value: "Hujan Lebat" },
  { title: "Hujan Sekejap", value: "Hujan Sekejap" }
];

export const weathersWithColors = [
  { name: "Cerah", color: "rgba(255, 233, 99, 1)" },
  { name: "Mendung", color: "rgba(255, 109, 109, 1)" },
  { name: "Hujan Renyai", color: "rgba(138, 208, 206, 1)" },
  { name: "Hujan Lebat", color: "rgba(189, 247, 255, 1)" },
  { name: "Hujan Sekejap", color: "rgba(75, 89, 94, 1)" }
];

export const bazarList = [
  //Perlis
  {
    title: "Bazar Ramadan Persiaran Wawasan, Kangar",
    value: "Bazar Ramadan Persiaran Wawasan, Kangar",
    state: "Perlis"
  },
  //Kedah
  {
    title: "Bazar Pasar Malam Kelang Lama",
    value: "Bazar Pasar Malam Kelang Lama",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Pekan Kulim",
    value: "Bazar Ramadan Pekan Kulim",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Taman Selasih",
    value: "Bazar Ramadan Taman Selasih",
    state: "Kedah"
  },
  {
    title: "Bazar Bandar Puteri Jaya",
    value: "Bazar Bandar Puteri Jaya",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Langgar",
    value: "Bazar Ramadan Langgar",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Kuala Ketil",
    value: "Bazar Ramadan Kuala Ketil",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Taman Nuri",
    value: "Bazar Ramadan Taman Nuri",
    state: "Kedah"
  },
  {
    title: "Bazar Kodiang",
    value: "Bazar Kodiang",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Pekan Pendang",
    value: "Bazar Ramadan Pekan Pendang",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Taman Ria",
    value: "Bazar Ramadan Taman Ria",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Tapak Stesen Bas Kubur Panjang",
    value: "Bazar Ramadan Tapak Stesen Bas Kubur Panjang",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Kuala Nerang",
    value: "Bazar Ramadan Kuala Nerang",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Taman Wira",
    value: "Bazar Ramadan Taman Wira",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Taman Mahsuri",
    value: "Bazar Ramadan Taman Mahsuri",
    state: "Kedah"
  },
  {
    title: "Bazar Pokok Sena",
    value: "Bazar Pokok Sena",
    state: "Kedah"
  },
  {
    title: "Bazar Pekan Tanah Merah Pendang",
    value: "Bazar Pekan Tanah Merah Pendang",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Padang Serai",
    value: "Bazar Ramadan Padang Serai",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Pekan Sik",
    value: "Bazar Ramadan Pekan Sik",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Tandop",
    value: "Bazar Ramadan Tandop",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Ayer Hitam",
    value: "Bazar Ramadan Ayer Hitam",
    state: "Kedah"
  },
  {
    title: "Bazar Dataran Penjaja Changlun",
    value: "Bazar Dataran Penjaja Changlun",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Kuala Kedah",
    value: "Bazar Ramadan Kuala Kedah",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Bukit Selambau",
    value: "Bazar Ramadan Bukit Selambau",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Pekan Kepala Batas",
    value: "Bazar Ramadan Pekan Kepala Batas",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Taman Seri Aman",
    value: "Bazar Ramadan Taman Seri Aman",
    state: "Kedah"
  },
  {
    title: "Bazar Ramadan Tapak Expo Sungai Korok",
    value: "Bazar Ramadan Tapak Expo Sungai Korok",
    state: "Kedah"
  },
  //Pulau Pinang
  {
    title: "Bazar Ramadan Masjid Daerah Seberang Perai Tengah",
    value: "Bazar Ramadan Masjid Daerah Seberang Perai Tengah",
    state: "Pulau Pinang"
  },
  {
    title: "Bazar Ramadan Balik Pulau",
    value: "Bazar Ramadan Balik Pulau",
    state: "Pulau Pinang"
  },
  {
    title: "Bazar Ramadan Taman Tun Sardon",
    value: "Bazar Ramadan Taman Tun Sardon",
    state: "Pulau Pinang"
  },
  {
    title: "Bazar Ramadan Bayan Lepas",
    value: "Bazar Ramadan Bayan Lepas",
    state: "Pulau Pinang"
  },
  {
    title: "Bazar Ramadan Bayan Baru",
    value: "Bazar Ramadan Bayan Baru",
    state: "Pulau Pinang"
  },
  //Perak
  {
    title: "Bazar Ramadan Stadium Ipoh",
    value: "Bazar Ramadan Stadium Ipoh",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Stadium Manjung",
    value: "Bazar Ramadan Stadium Manjung",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Behrang 2020",
    value: "Bazar Ramadan Behrang 2020",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Bougainvilla Kuala Kangsar",
    value: "Bazar Ramadan Bougainvilla Kuala Kangsar",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Tapah Road",
    value: "Bazar Ramadan Tapah Road",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Selekoh Bagan Datuk",
    value: "Bazar Ramadan Selekoh Bagan Datuk",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Taman Perpaduan Ipoh",
    value: "Bazar Ramadan Taman Perpaduan Ipoh",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Taman Cempaka Ipoh",
    value: "Bazar Ramadan Taman Cempaka Ipoh",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Kamunting",
    value: "Bazar Ramadan Kamunting",
    state: "Perak"
  },
  {
    title: "Bazar SIBC Seri Iskandar",
    value: "Bazar SIBC Seri Iskandar",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Dataran Orkid Batu Gajah",
    value: "Bazar Ramadan Dataran Orkid Batu Gajah",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Pekan Teluk Intan @ OCBC Bank",
    value: "Bazar Ramadan Pekan Teluk Intan @ OCBC Bank",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Silibin Utara Ipoh",
    value: "Bazar Ramadan Silibin Utara Ipoh",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Dataran Niaga Seri Iskandar",
    value: "Bazar Ramadan Dataran Niaga Seri Iskandar",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Politeknik Ungku Omar Ipoh",
    value: "Bazar Ramadan Politeknik Ungku Omar Ipoh",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Medan Gopeng Ipoh",
    value: "Bazar Ramadan Medan Gopeng Ipoh",
    state: "Perak"
  },
  {
    title: "Bazar Ramadan Kg Bahagia Teluk Intan",
    value: "Bazar Ramadan Kg Bahagia Teluk Intan",
    state: "Perak"
  },
  {
    title: "Bazar Arena Square",
    value: "Bazar Arena Square",
    state: "Perak"
  },
  //Kelantan
  {
    title: "Bazar Ramadan Mydin Tunjong",
    value: "Bazar Ramadan Mydin Tunjong",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Taman Bendahara",
    value: "Bazar Ramadan Taman Bendahara",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Stadium",
    value: "Bazar Ramadan Stadium",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Lembah Sireh",
    value: "Bazar Ramadan Lembah Sireh",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Kok Lanas",
    value: "Bazar Ramadan Kok Lanas",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Berek 12",
    value: "Bazar Ramadan Berek 12",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Lundang",
    value: "Bazar Ramadan Lundang",
    state: "Kelantan"
  },
  {
    title: "Bazar Ramadan Belakang KB Mall",
    value: "Bazar Ramadan Belakang KB Mall",
    state: "Kelantan"
  },
  //Terengganu
  {
    title: "Bazar Ramadan Kuala Berang",
    value: "Bazar Ramadan Kuala Berang",
    state: "Terengganu"
  },
  {
    title: "Bazar Ramadan Gong Badak",
    value: "Bazar Ramadan Gong Badak",
    state: "Terengganu"
  },
  {
    title: "Bazar Wakaf Tengah",
    value: "Bazar Wakaf Tengah",
    state: "Terengganu"
  },
  {
    title: "Bazar Kampung Raja",
    value: "Bazar Kampung Raja",
    state: "Terengganu"
  },
  {
    title: "Bazar Ramadan Batu Buruk",
    value: "Bazar Ramadan Batu Buruk",
    state: "Terengganu"
  },
  {
    title: "Bazar Ramadan Sungai Tarom",
    value: "Bazar Ramadan Sungai Tarom",
    state: "Terengganu"
  },
  {
    title: "Bazar Pasar Malam Paka",
    value: "Bazar Pasar Malam Paka",
    state: "Terengganu"
  },
  //Pahang
  {
    title: "Bazar Ramadan Pantai Selamat IM",
    value: "Bazar Ramadan Pantai Selamat IM",
    state: "Pahang"
  },
  {
    title: "Bazar Ramadan Muadzam Shah",
    value: "Bazar Ramadan Muadzam Shah",
    state: "Pahang"
  },
  {
    title: "Bazar Taman Tasik Sultan Abu Bakar",
    value: "Bazar Taman Tasik Sultan Abu Bakar",
    state: "Pahang"
  },
  {
    title: "Bazar Ramadan Mahkota Square",
    value: "Bazar Ramadan Mahkota Square",
    state: "Pahang"
  },
  {
    title: "Bazar Padang MBK 1, Kuantan",
    value: "Bazar Padang MBK 1, Kuantan",
    state: "Pahang"
  },
  //Selangor
  {
    title: "Bazar Ramadan Taman Samudera",
    value: "Bazar Ramadan Taman Samudera",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Dengkil Jaya",
    value: "Bazar Ramadan Dengkil Jaya",
    state: "Selangor"
  },
  {
    title: "Bazar Sungai Besar",
    value: "Bazar Sungai Besar",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Prima Saujana Kajang",
    value: "Bazar Ramadan Prima Saujana Kajang",
    state: "Selangor"
  },
  {
    title: "Bazar Pasar Awam Taman Bunga Raya",
    value: "Bazar Pasar Awam Taman Bunga Raya",
    state: "Selangor"
  },
  {
    title: "Bazar Banting",
    value: "Bazar Banting",
    state: "Selangor"
  },
  {
    title: "Bazar Laman Niaga Komuniti Bandar Baru Bangi",
    value: "Bazar Laman Niaga Komuniti Bandar Baru Bangi",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Cyberjaya",
    value: "Bazar Ramadan Cyberjaya",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Kota Warisan",
    value: "Bazar Ramadan Kota Warisan",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Sungai Tangkas, Kajang",
    value: "Bazar Ramadan Sungai Tangkas, Kajang",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Saujana Utama",
    value: "Bazar Ramadan Saujana Utama",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Seksyen 3 Bangi",
    value: "Bazar Ramadan Seksyen 3 Bangi",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Kosmoplek, Salak Tinggi",
    value: "Bazar Ramadan Kosmoplek, Salak Tinggi",
    state: "Selangor"
  },
  {
    title: "Bazar Simpang Empat Sg Udang, Klang",
    value: "Bazar Simpang Empat Sg Udang, Klang",
    state: "Selangor"
  },
  {
    title: "Bazar Sri Andalas Klang",
    value: "Bazar Sri Andalas Klang",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Seksyen U16 Denai Alam Shah Alam",
    value: "Bazar Ramadan Seksyen U16 Denai Alam Shah Alam",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Seksyen 19, Shah Alam",
    value: "Bazar Ramadan Seksyen 19, Shah Alam",
    state: "Selangor"
  },
  {
    title: "Bazar Padang Perbandaran Pandan Indah MPAJ",
    value: "Bazar Padang Perbandaran Pandan Indah MPAJ",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Seksyen 13 Shah Alam",
    value: "Bazar Ramadan Seksyen 13 Shah Alam",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan Bandar Baru Ampang",
    value: "Bazar Ramadan Bandar Baru Ampang",
    state: "Selangor"
  },
  {
    title: "Bazar Kompleks Muhibbah, Taman Nirwana, Ampang",
    value: "Bazar Kompleks Muhibbah, Taman Nirwana, Ampang",
    state: "Selangor"
  },
  {
    title: "Bazar Bandar Seri Putra",
    value: "Bazar Bandar Seri Putra",
    state: "Selangor"
  },
  {
    title: "Bazar Ramadan JRD Batang Kali",
    value: "Bazar Ramadan JRD Batang Kali",
    state: "Selangor"
  },
  {
    title: "Bazar Pasar Malam Jalan Orkid",
    value: "Bazar Pasar Malam Jalan Orkid",
    state: "Selangor"
  },
  //Kuala Lumpur
  {
    title: "Bazar Wangsa Maju",
    value: "Bazar Wangsa Maju",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Hadapan Pusat Penaja Bazaria Lembah Pantai",
    value: "Bazar Hadapan Pusat Penaja Bazaria Lembah Pantai",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Ramadan Kampung Baru Jalan Raja Alang",
    value: "Bazar Ramadan Kampung Baru Jalan Raja Alang",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Sri Rampai Jalan Rajang 1",
    value: "Bazar Sri Rampai Jalan Rajang 1",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar TLK Taman Permaisuri",
    value: "Bazar TLK Taman Permaisuri",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar TLK Hadapan UTC Sentul",
    value: "Bazar TLK Hadapan UTC Sentul",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Desa Pandan Jalan 3/76D",
    value: "Bazar Desa Pandan Jalan 3/76D",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Kampung Baru Jalan Raja Uda",
    value: "Bazar Kampung Baru Jalan Raja Uda",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Taman Dato Senu Jalan Dato Senu 18",
    value: "Bazar Taman Dato Senu Jalan Dato Senu 18",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Desa Pandan Jalan 1/76C",
    value: "Bazar Desa Pandan Jalan 1/76C",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Jalan Wangsa Delima, Wangsa Maju",
    value: "Bazar Jalan Wangsa Delima, Wangsa Maju",
    state: "Kuala Lumpur"
  },
  {
    title:
      "Bazar Danau Kota Jalan 3A/6, Jalan 4A/6, Jalan 5A/6 Taman Setapak Indah",
    value:
      "Bazar Danau Kota Jalan 3A/6, Jalan 4A/6, Jalan 5A/6 Taman Setapak Indah",
    state: "Kuala Lumpur"
  },
  {
    title: "Bazar Bukit Bintang",
    value: "Bazar Bukit Bintang",
    state: "Kuala Lumpur"
  },
  //Putrajaya
  {
    title: "Bazar Ramadan Presint 3, Putrajaya",
    value: "Bazar Ramadan Presint 3, Putrajaya",
    state: "Putrajaya"
  },
  //Negeri Sembilan
  {
    title: "Bazar Jalan BBN 1/7",
    value: "Bazar Jalan BBN 1/7",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Jalan BBN 1/2A",
    value: "Bazar Jalan BBN 1/2A",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Stadium Paroi",
    value: "Bazar Stadium Paroi",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Kota Seriemas",
    value: "Bazar Kota Seriemas",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Sendayan",
    value: "Bazar Sendayan",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Lotus Nilai",
    value: "Bazar Lotus Nilai",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Taman Pinggiran Senawang",
    value: "Bazar Taman Pinggiran Senawang",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Dataran Melang, Pilah",
    value: "Bazar Dataran Melang, Pilah",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Batu 4, PD",
    value: "Bazar Batu 4, PD",
    state: "Negeri Sembilan"
  },
  {
    title: "Bazar Pekan Rembau",
    value: "Bazar Pekan Rembau",
    state: "Negeri Sembilan"
  },
  //Melaka
  {
    title: "Bazar Ramadan Taman Peringgit, Melaka",
    value: "Bazar Ramadan Taman Peringgit, Melaka",
    state: "Melaka"
  },
  {
    title: "Bazar Ramadan MITC",
    value: "Bazar Ramadan MITC",
    state: "Melaka"
  },
  {
    title: "Bazar Ramadan Jasin",
    value: "Bazar Ramadan Jasin",
    state: "Melaka"
  },
  {
    title: "Bazar Alor Gajah",
    value: "Bazar Alor Gajah",
    state: "Melaka"
  },
  //Johor
  {
    title: "Bazar Ramadan Indahpura Kulai",
    value: "Bazar Ramadan Indahpura Kulai",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Perling Mall Johor Bahru",
    value: "Bazar Ramadan Perling Mall Johor Bahru",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Dahlia Johor Bahru",
    value: "Bazar Ramadan Taman Dahlia Johor Bahru",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Yayasan Segamat",
    value: "Bazar Ramadan Taman Yayasan Segamat",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Pesta Batu Pahat",
    value: "Bazar Ramadan Pesta Batu Pahat",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Wawasan Mersing",
    value: "Bazar Ramadan Taman Wawasan Mersing",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Jalan Mawar Kota Tinggi",
    value: "Bazar Ramadan Jalan Mawar Kota Tinggi",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Laman Simpang Renggam",
    value: "Bazar Ramadan Laman Simpang Renggam",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Mini Stadium Pontian",
    value: "Bazar Ramadan Mini Stadium Pontian",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Dewan Jubli Intan Muar",
    value: "Bazar Ramadan Dewan Jubli Intan Muar",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Pagoh Jaya",
    value: "Bazar Ramadan Pagoh Jaya",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Jalan Enggang Kulai",
    value: "Bazar Ramadan Jalan Enggang Kulai",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Dato Onn JB",
    value: "Bazar Ramadan Dato Onn JB",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Pulai Mutiara IP",
    value: "Bazar Ramadan Taman Pulai Mutiara IP",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Rinting PG",
    value: "Bazar Ramadan Taman Rinting PG",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Budaya Batu Pahat",
    value: "Bazar Ramadan Taman Budaya Batu Pahat",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Intan Kluang",
    value: "Bazar Ramadan Taman Intan Kluang",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Bandar Putra Segamat",
    value: "Bazar Ramadan Bandar Putra Segamat",
    state: "Johor"
  },
  {
    title: "Bazar Ramadan Taman Sri Saujana KT",
    value: "Bazar Ramadan Taman Sri Saujana KT",
    state: "Johor"
  },
  //Sarawak
  {
    title: "Bazar Bintulu Esplanade",
    value: "Bazar Bintulu Esplanade",
    state: "Sarawak"
  },
  {
    title: "Bazar Emart Batu Kawa",
    value: "Bazar Emart Batu Kawa",
    state: "Sarawak"
  },
  {
    title: "Bazar The Summer Shopping Mall",
    value: "Bazar The Summer Shopping Mall",
    state: "Sarawak"
  },
  {
    title: "Bazar Hikmah Exchange Event Centre",
    value: "Bazar Hikmah Exchange Event Centre",
    state: "Sarawak"
  },
  {
    title: "Bazar Jun Rong Stutong",
    value: "Bazar Jun Rong Stutong",
    state: "Sarawak"
  },
  {
    title: "Bazar Emart Xpress Sukma Ria",
    value: "Bazar Emart Xpress Sukma Ria",
    state: "Sarawak"
  },
  {
    title: "Bazar Emart Matang",
    value: "Bazar Emart Matang",
    state: "Sarawak"
  },
  //Sabah
  {
    title: "Bazar Ramadan Bataras Bandar Baru Keningau",
    value: "Bazar Ramadan Bataras Bandar Baru Keningau",
    state: "Sabah"
  },
  {
    title: "Bazar Ramadan Aeropod Night Market",
    value: "Bazar Ramadan Aeropod Night Market",
    state: "Sabah"
  },
  {
    title: "Bazar Ramadan Sabindo Tawau",
    value: "Bazar Ramadan Sabindo Tawau",
    state: "Sabah"
  },
  {
    title: "Bazar Ramadan Dataran Bagandang",
    value: "Bazar Ramadan Dataran Bagandang",
    state: "Sabah"
  },
  {
    title: "Bazar Ramadan Pekan Papar",
    value: "Bazar Ramadan Pekan Papar",
    state: "Sabah"
  }
];

export const areaList = [
  // Perlis
  { title: "Abi", value: "Abi", state: "Perlis" },
  { title: "Arau", value: "Arau", state: "Perlis" },
  { title: "Beseri", value: "Beseri", state: "Perlis" },
  { title: "Chuping", value: "Chuping", state: "Perlis" },
  { title: "Utan Aji", value: "Utan Aji", state: "Perlis" },
  { title: "Jejawi", value: "Jejawi", state: "Perlis" },
  { title: "Kayang", value: "Kayang", state: "Perlis" },
  { title: "Kechor", value: "Kechor", state: "Perlis" },
  { title: "Kuala Perlis", value: "Kuala Perlis", state: "Perlis" },
  { title: "Kurong Anai", value: "Kurong Anai", state: "Perlis" },
  { title: "Kurong Batang", value: "Kurong Batang", state: "Perlis" },
  { title: "Ngulang", value: "Ngulang", state: "Perlis" },
  { title: "Oran", value: "Oran", state: "Perlis" },
  { title: "Padang Pauh", value: "Padang Pauh", state: "Perlis" },
  { title: "Padang Siding", value: "Padang Siding", state: "Perlis" },
  { title: "Paya", value: "Paya", state: "Perlis" },
  { title: "Sena", value: "Sena", state: "Perlis" },
  { title: "Seriab", value: "Seriab", state: "Perlis" },
  { title: "Sungei Adam", value: "Sungei Adam", state: "Perlis" },
  { title: "Titi Tinggi", value: "Titi Tinggi", state: "Perlis" },
  { title: "Wang Bintong", value: "Wang Bintong", state: "Perlis" },
  { title: "Sungei Limau", value: "Sungei Limau", state: "Perlis" },
  // Kedah
  { title: "Baling", value: "Baling", state: "Kedah" },
  { title: "Bandar Baharu", value: "Bandar Baharu", state: "Kedah" },
  { title: "Kota Setar", value: "Kota Setar", state: "Kedah" },
  { title: "Kuala Muda", value: "Kuala Muda", state: "Kedah" },
  { title: "Kubang Pasu", value: "Kubang Pasu", state: "Kedah" },
  { title: "Kulim", value: "Kulim", state: "Kedah" },
  { title: "Langkawi", value: "Langkawi", state: "Kedah" },
  { title: "Padang Terap", value: "Padang Terap", state: "Kedah" },
  { title: "Pendang", value: "Pendang", state: "Kedah" },
  { title: "Pokok Sena", value: "Pokok Sena", state: "Kedah" },
  { title: "Sik", value: "Sik", state: "Kedah" },
  { title: "Yan", value: "Yan", state: "Kedah" },
  // Pulau Pinang
  {
    title: "Daerah Timur Laut (DTL)",
    value: "Daerah Timur Laut (DTL)",
    state: "Pulau Pinang"
  },
  {
    title: "Daerah Barat Daya (DBD)",
    value: "Daerah Barat Daya (DBD)",
    state: "Pulau Pinang"
  },
  {
    title: "Seberang Perai Utara (SPU)",
    value: "Seberang Perai Utara (SPU)",
    state: "Pulau Pinang"
  },
  {
    title: "Seberang Perai Tengah (SPT)",
    value: "Seberang Perai Tengah (SPT)",
    state: "Pulau Pinang"
  },
  {
    title: "Seberang Perai Selatan (SPS)",
    value: "Seberang Perai Selatan (SPS)",
    state: "Pulau Pinang"
  },
  // Perak
  { title: "Batang Padang", value: "Batang Padang", state: "Perak" },
  { title: "Hilir Perak", value: "Hilir Perak", state: "Perak" },
  { title: "Hulu Perak", value: "Hulu Perak", state: "Perak" },
  { title: "Kampar", value: "Kampar", state: "Perak" },
  { title: "Kerian", value: "Kerian", state: "Perak" },
  { title: "Kinta", value: "Kinta", state: "Perak" },
  { title: "Kuala Kangsar", value: "Kuala Kangsar", state: "Perak" },
  {
    title: "Larut, Matang dan Selama",
    value: "Larut, Matang dan Selama",
    state: "Perak"
  },
  { title: "Manjung", value: "Manjung", state: "Perak" },
  { title: "Muallim", value: "Muallim", state: "Perak" },
  { title: "Perak Tengah", value: "Perak Tengah", state: "Perak" },
  { title: "Bagan Datuk", value: "Bagan Datuk", state: "Perak" },
  // Kelantan
  { title: "Kota Bharu", value: "Kota Bharu", state: "Kelantan" },
  { title: "Pasir Mas", value: "Pasir Mas", state: "Kelantan" },
  { title: "Tumpat", value: "Tumpat", state: "Kelantan" },
  { title: "Pasir Puteh", value: "Pasir Puteh", state: "Kelantan" },
  { title: "Bachok", value: "Bachok", state: "Kelantan" },
  { title: "Kuala Krai", value: "Kuala Krai", state: "Kelantan" },
  { title: "Machang", value: "Machang", state: "Kelantan" },
  { title: "Tanah Merah", value: "Tanah Merah", state: "Kelantan" },
  { title: "Jeli", value: "Jeli", state: "Kelantan" },
  { title: "Gua Musang", value: "Gua Musang", state: "Kelantan" },
  { title: "Lojing", value: "Lojing", state: "Kelantan" },
  // Terengganu
  { title: "Besut", value: "Besut", state: "Terengganu" },
  { title: "Dungun", value: "Dungun", state: "Terengganu" },
  { title: "Hulu Terengganu", value: "Hulu Terengganu", state: "Terengganu" },
  { title: "Kemaman", value: "Kemaman", state: "Terengganu" },
  { title: "Kuala Terengganu", value: "Kuala Terengganu", state: "Terengganu" },
  { title: "Marang", value: "Marang", state: "Terengganu" },
  { title: "Setiu", value: "Setiu", state: "Terengganu" },
  { title: "Kuala Nerus", value: "Kuala Nerus", state: "Terengganu" },
  // Pahang
  { title: "Bentong", value: "Bentong", state: "Pahang" },
  { title: "Bera", value: "Bera", state: "Pahang" },
  { title: "Cameron Highlands", value: "Cameron Highlands", state: "Pahang" },
  { title: "Jerantut", value: "Jerantut", state: "Pahang" },
  { title: "Kuantan", value: "Kuantan", state: "Pahang" },
  { title: "Lipis", value: "Lipis", state: "Pahang" },
  { title: "Maran", value: "Maran", state: "Pahang" },
  { title: "Pekan", value: "Pekan", state: "Pahang" },
  { title: "Raub", value: "Raub", state: "Pahang" },
  { title: "Rompin", value: "Rompin", state: "Pahang" },
  { title: "Temerloh", value: "Temerloh", state: "Pahang" },
  // Selangor
  { title: "Gombak", value: "Gombak", state: "Selangor" },
  { title: "Hulu Langat", value: "Hulu Langat", state: "Selangor" },
  { title: "Hulu Selangor", value: "Hulu Selangor", state: "Selangor" },
  { title: "Klang", value: "Klang", state: "Selangor" },
  { title: "Kuala Langat", value: "Kuala Langat", state: "Selangor" },
  { title: "Kuala Selangor", value: "Kuala Selangor", state: "Selangor" },
  { title: "Petaling", value: "Petaling", state: "Selangor" },
  { title: "Sabak Bernam", value: "Sabak Bernam", state: "Selangor" },
  { title: "Sepang", value: "Sepang", state: "Selangor" },
  // Kuala Lumpur
  { title: "Seputeh", value: "Seputeh", state: "Kuala Lumpur" },
  {
    title: "Bandar Tun Razak",
    value: "Bandar Tun Razak",
    state: "Kuala Lumpur"
  },
  { title: "Cheras", value: "Cheras", state: "Kuala Lumpur" },
  { title: "Bukit Bintang", value: "Bukit Bintang", state: "Kuala Lumpur" },
  { title: "Lembah Pantai", value: "Lembah Pantai", state: "Kuala Lumpur" },
  { title: "Titiwangsa", value: "Titiwangsa", state: "Kuala Lumpur" },
  { title: "Setiawangsa", value: "Setiawangsa", state: "Kuala Lumpur" },
  { title: "Wangsa Maju", value: "Wangsa Maju", state: "Kuala Lumpur" },
  { title: "Batu", value: "Batu", state: "Kuala Lumpur" },
  { title: "Segambut", value: "Segambut", state: "Kuala Lumpur" },
  { title: "Kepong", value: "Kepong", state: "Kuala Lumpur" },
  // Putrajaya
  { title: "Putrajaya", value: "Putrajaya", state: "Putrajaya" },
  // Negeri Sembilan
  { title: "Port Dickson", value: "Port Dickson", state: "Negeri Sembilan" },
  { title: "Rembau", value: "Rembau", state: "Negeri Sembilan" },
  { title: "Rasah", value: "Rasah", state: "Negeri Sembilan" },
  { title: "Seremban", value: "Seremban", state: "Negeri Sembilan" },
  { title: "Kuala Pilah", value: "Kuala Pilah", state: "Negeri Sembilan" },
  { title: "Jelebu", value: "Jelebu", state: "Negeri Sembilan" },
  { title: "Jempol", value: "Jempol", state: "Negeri Sembilan" },
  { title: "Tampin", value: "Tampin", state: "Negeri Sembilan" },
  // Melaka
  { title: "Jasin", value: "Jasin", state: "Melaka" },
  { title: "Bukit Katil", value: "Bukit Katil", state: "Melaka" },
  { title: "Tangga Batu", value: "Tangga Batu", state: "Melaka" },
  { title: "Masjid Tanah", value: "Masjid Tanah", state: "Melaka" },
  { title: "Alor Gajah", value: "Alor Gajah", state: "Melaka" },
  // Johor
  { title: "Johor Bahru", value: "Johor Bahru", state: "Johor" },
  { title: "Pontian", value: "Pontian", state: "Johor" },
  { title: "Kulai Jaya", value: "Kulai Jaya", state: "Johor" },
  { title: "Kota Tinggi", value: "Kota Tinggi", state: "Johor" },
  { title: "Mersing", value: "Mersing", state: "Johor" },
  { title: "Kluang", value: "Kluang", state: "Johor" },
  { title: "Batu Pahat", value: "Batu Pahat", state: "Johor" },
  { title: "Muar", value: "Muar", state: "Johor" },
  { title: "Segamat", value: "Segamat", state: "Johor" },
  { title: "Ledang", value: "Ledang", state: "Johor" },
  // Sarawak
  { title: "Kuching", value: "Kuching", state: "Sarawak" },
  { title: "Kota Samarahan", value: "Kota Samarahan", state: "Sarawak" },
  { title: "Sri Aman", value: "Sri Aman", state: "Sarawak" },
  { title: "Sibu", value: "Sibu", state: "Sarawak" },
  { title: "Bintulu", value: "Bintulu", state: "Sarawak" },
  { title: "Miri", value: "Miri", state: "Sarawak" },
  // Sabah
  { title: "Tawau", value: "Tawau", state: "Sabah" },
  { title: "Kunak", value: "Kunak", state: "Sabah" },
  { title: "Semporna", value: "Semporna", state: "Sabah" },
  { title: "Lahad Datu", value: "Lahad Datu", state: "Sabah" },
  { title: "Kinabatangan", value: "Kinabatangan", state: "Sabah" },
  { title: "Sandakan", value: "Sandakan", state: "Sabah" },
  { title: "Beluran", value: "Beluran", state: "Sabah" },
  { title: "Pilas", value: "Pilas", state: "Sabah" },
  { title: "Kudat", value: "Kudat", state: "Sabah" },
  { title: "Kota Marudu", value: "Kota Marudu", state: "Sabah" },
  { title: "Ranau", value: "Ranau", state: "Sabah" },
  { title: "Telupid", value: "Telupid", state: "Sabah" },
  { title: "Tongod", value: "Tongod", state: "Sabah" },
  { title: "Nabawan", value: "Nabawan", state: "Sabah" },
  { title: "Keningau", value: "Keningau", state: "Sabah" },
  { title: "Tambunan", value: "Tambunan", state: "Sabah" },
  { title: "Tuaran", value: "Tuaran", state: "Sabah" },
  { title: "Kota Kinabalu", value: "Kota Kinabalu", state: "Sabah" },
  { title: "Penampang", value: "Penampang", state: "Sabah" },
  { title: "Papar", value: "Papar", state: "Sabah" },
  { title: "Tenom", value: "Tenom", state: "Sabah" },
  { title: "Beaufort", value: "Beaufort", state: "Sabah" },
  { title: "Sipitang", value: "Sipitang", state: "Sabah" },
  { title: "Kuala Penyu", value: "Kuala Penyu", state: "Sabah" },
  { title: "Putatan", value: "Putatan", state: "Sabah" },
  // Labuan
  { title: "WP Labuan", value: "WP Labuan", state: "Labuan" }
];

export const foodType = [
  {
    title: "Nasi Berlauk (nasi ayam/tomato/ambeng/biryani/gulai dll)",
    value: "Nasi Berlauk"
  },
  { title: "Kuih Muih (kek, kuih)", value: "Kuih Muih" },
  {
    title: "Nasi/mee/bihun/kueytiaw Goreng",
    value: "Makanan Berat Goreng"
  },
  {
    title: "Berkuah (laksa, mee kari, bihun sup dll)",
    value: "Makanan Berat Berkuah"
  },
  {
    title: "Goreng2 dan Bakar2 (percik, sate, ayam/sotong/bola goreng dll)",
    value: "Goreng2 dan Bakar2"
  },
  { title: "Western (pizza, spaghetti, dll)", value: "Western" },
  {
    title: "Side Dish (murtabak, roti jala, kebab, roti john dll)",
    value: "Side Dish"
  },
  {
    title: "Lain-lain",
    value: "Others"
  },
  { title: "Minuman (Semua jenis Air)", value: "Minuman" }
];

export const days = [
  "14/03",
  "15/03",
  "16/03",
  "17/03",
  "18/03",
  "19/03",
  "20/03",
  "21/03",
  "22/03",
  "23/03",
  "24/03",
  "25/03",
  "26/03",
  "27/03",
  "28/03",
  "29/03",
  "30/03",
  "31/03",
  "01/04",
  "02/04",
  "03/04",
  "04/04",
  "05/04",
  "06/04",
  "07/04",
  "08/04",
  "09/04",
  "10/04"
];
